var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BD2624",
    d: "M0 17.5C0 7.835 7.833 0 17.5 0 27.165 0 35 7.833 35 17.5 35 27.165 27.167 35 17.5 35 7.835 35 0 27.167 0 17.5z",
    transform: "translate(-200.000000, -314.000000) translate(185.000000, 299.000000) translate(15.000000, 15.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2.794c-.392.01-.773-.126-1.07-.38-.284-.25-.441-.613-.427-.99C-.025 1.027.133.639.431.37c.625-.493 1.513-.493 2.138 0 .298.269.456.657.428 1.054.014.377-.143.74-.428.99-.296.254-.677.39-1.069.38zM.26 4.65h2.459V15H.259V4.65z",
    transform: "translate(-200.000000, -314.000000) translate(185.000000, 299.000000) translate(15.000000, 15.000000) translate(17.500000, 17.500000) rotate(-180.000000) translate(-17.500000, -17.500000) translate(16.000000, 10.000000)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.90ac4d5f7dbd8700b72f72bbe553bfe7.svg";
export { ForwardRef as ReactComponent };